import { render, staticRenderFns } from "./PlansView.vue?vue&type=template&id=dc4b376e&scoped=true&"
import script from "./PlansView.vue?vue&type=script&lang=js&"
export * from "./PlansView.vue?vue&type=script&lang=js&"
import style0 from "./PlansView.vue?vue&type=style&index=0&id=dc4b376e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b376e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VContainer,VIcon,VSelect,VSimpleTable})
